(function () {
	'use strict';

	angular
		.module('wizard-english-test.routes')
		.config(routes);

	/** @ngInject */
	function routes($stateProvider, $locationProvider, PATHS, $urlRouterProvider) {
		$locationProvider.html5Mode(true);
		$urlRouterProvider.otherwise('/nao-encontrado');

		var defaultConfiguration = {
			LoginActive: 0,
			RegistrationActive: 0,
			Regulation: "",
			ShowProjects: 0
		};

		$stateProvider
			.state('app', {
				abstract: true,
				templateUrl: `${PATHS.PHYSICAL}/components/layout/layout.html`,
				onEnter: ($rootScope) => {
					$rootScope.hideLoading = true;
				}
			})
			.state('app.home', {
				title: 'Início',
				url: '/',
				templateUrl: `${PATHS.PHYSICAL}/components/homepage/homepage.html`,
				controller: 'HomepageController',
				controllerAs: 'vm'
			})
			.state('app.chat', {
				title: 'Chat',
				url: '/chat',
				templateUrl: `${PATHS.PHYSICAL}/components/chat/chat.html`,
				controller: 'ChatController',
				controllerAs: 'vm',
				params: {
					endTestMessage: {
						dynamic: true,
						squash: false
					}
				}
			})
			.state('app.result', {
				title: 'Resultado',
				url: '/resultado',
				templateUrl: `${PATHS.PHYSICAL}/components/chat/chat.html`,
				controller: 'ChatController',
				controllerAs: 'vm',
				params: {
					endTestMessage: {
						dynamic: true,
						squash: false
					}
				}
			})
			.state('app.quiz', {
				title: 'Quiz',
				url: '/quiz',
				templateUrl: `${PATHS.PHYSICAL}/components/quiz/quiz.html`,
				controller: 'QuizController',
				controllerAs: 'vm'
			})
			.state('app.not-found', {
				title: 'Não encontrado',
				url: '/nao-encontrado',
				templateUrl: `${PATHS.PHYSICAL}/components/common/not-found.html`,
				controller: 'HomepageController',
				controllerAs: 'vm'
			})
			.state('app.not-authorized', {
				title: 'Não autorizado',
				url: '/nao-autorizado',
				templateUrl: `${PATHS.PHYSICAL}/components/common/not-authorized.html`,
				controller: 'HomepageController',
				controllerAs: 'vm'
			})
            .state('app.event', {
                title: 'Evento',
                url: '/:url',
                templateUrl: `${PATHS.PHYSICAL}/components/chat/chat.html`,
                controller: 'ChatController',
                controllerAs: 'vm',
                params: {
                    endTestMessage: {
                        dynamic: true,
                        squash: false
                    }
                }
            })
    }
}());